import { render, staticRenderFns } from "./OrbitSetupFormStep.vue?vue&type=template&id=4d9fb36d&scoped=true"
import script from "./OrbitSetupFormStep.vue?vue&type=script&lang=ts"
export * from "./OrbitSetupFormStep.vue?vue&type=script&lang=ts"
import style0 from "./OrbitSetupFormStep.vue?vue&type=style&index=0&id=4d9fb36d&prod&lang=scss&scoped=true"
import style1 from "./OrbitSetupFormStep.vue?vue&type=style&index=1&id=4d9fb36d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9fb36d",
  null
  
)

export default component.exports